<template>
  <CommonModal>
    <div class="flex flex-col h-full">
      <div class="flex-grow modal-scroll">
        <table
          v-if="lot.attributes"
          class="my-1 text-xs w-full shadow"  
        >
          <tr
            v-for="attribute in Object.keys(lot.attributes)"
            :key="'attributes-modal-' + lot.uuid + '-' + attribute"
          >
            <td class="p-1 text-xs font-bold">
              {{ $t("lot.attributes." + attribute + ".name") }}
            </td>
            <td class="p-1 text-xs text-center">
              <template v-if="attribute == 'dataDisponibilitaMateriale'">
                {{ lot.attributes[attribute] }}
              </template>
              <template v-else>
                {{ lot.attributes[attribute] ? $t("lot.attributes." + attribute + ".values." + lot.attributes[attribute]) : '-' }}
              </template>
            </td>
          </tr>
        </table>
      </div>
      <div>
        <a
          href="#"
          class="btn btn-cancel"
          @click.prevent="$emit('close')"
        >{{ $t("common.close") }}</a>
      </div>
    </div>
  </CommonModal>
</template>
  
  <script setup>
  import CommonModal from '@/components/CommonModal.vue';
  
  const emit = defineEmits(['close'])
  const props = defineProps({
      lot: {
          type: Object,
          required: true
      }
  })
  
  </script>